import { Component, signal } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AgGridAngular } from 'ag-grid-angular';
import { ColDef, GridReadyEvent } from 'ag-grid-community';

import { HistoryRuleRecord } from '../../model/history-rule-record';

@Component({
  selector: 'ama-app-history-modal',
  templateUrl: './history-modal.component.html',
  styleUrls: ['./history-modal.component.scss'],
  imports: [AgGridAngular]
})
export class HistoryModalComponent {
  ruleName = signal<string>('');
  isLoading = signal<boolean>(false);
  columnDefs: ColDef[] = [
    {
      headerName: 'Action',
      field: 'action',
      width: 120
    },
    {
      headerName: 'Date',
      field: 'date',
      width: 150
    },
    {
      headerName: 'Time',
      field: 'time',
      width: 120
    },
    {
      headerName: 'User',
      field: 'user',
      width: 100
    }
  ];
  rowData: HistoryRuleRecord[] = [];

  defaultColDef = {
    sortable: true,
    suppressMovable: true,
    resizable: false
  };

  gridOptions = {
    theme: 'legacy' as const,
    pagination: true,
    paginationPageSize: 10,
    paginationPageSizeSelector: [10, 20, 30],
    localeText: {
      pageSizeSelectorLabel: $localize`:@@upp.global.pagination.recordsPerPage:Records per page:`
    },
    unSortIcon: true,
    suppressCellFocus: true
  };

  constructor(public activeModal: NgbActiveModal) {}

  onGridReady(params: GridReadyEvent) {
    params.api.sizeColumnsToFit();
  }

  close() {
    this.activeModal.close();
  }
}
